import {
  LEFT_MAIL_PROCESSING_CENTER_CHECKED,
  LEFT_POSTAL_OPERATOR_CHECKED,
  LEFT_POSTAL_OPERATOR_EXPANDED,
  RETRIEVE_ALL_LEFT_OPERATORS_FAILURE,
  RETRIEVE_ALL_LEFT_OPERATORS_REQUEST,
  RETRIEVE_ALL_LEFT_OPERATORS_SUCCESS,
  RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_FAILURE,
  RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_REQUEST,
  RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_SUCCESS,
  RETRIEVE_ALL_RIGHT_OPERATORS_FAILURE,
  RETRIEVE_ALL_RIGHT_OPERATORS_REQUEST,
  RETRIEVE_ALL_RIGHT_OPERATORS_SUCCESS,
  RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_FAILURE,
  RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_REQUEST,
  RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_SUCCESS,
  RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_FAILURE,
  RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST,
  RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS,
  RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_FAILURE,
  RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_REQUEST,
  RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_SUCCESS,
  RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_FAILURE,
  RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_REQUEST,
  RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_SUCCESS,
  RETRIEVE_LEFT_OPERATORS_BY_ROLE_FAILURE,
  RETRIEVE_LEFT_OPERATORS_BY_ROLE_REQUEST,
  RETRIEVE_LEFT_OPERATORS_BY_ROLE_SUCCESS,
  RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_FAILURE,
  RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST,
  RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS,
  RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_FAILURE,
  RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST,
  RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS,
  RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_FAILURE,
  RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_REQUEST,
  RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_SUCCESS,
  RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_FAILURE,
  RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_REQUEST,
  RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_SUCCESS,
  RETRIEVE_RIGHT_OPERATORS_BY_ROLE_FAILURE,
  RETRIEVE_RIGHT_OPERATORS_BY_ROLE_REQUEST,
  RETRIEVE_RIGHT_OPERATORS_BY_ROLE_SUCCESS,
  RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_FAILURE,
  RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST,
  RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS,
  RIGHT_MAIL_PROCESSING_CENTER_CHECKED,
  RIGHT_POSTAL_OPERATOR_CHECKED,
  RIGHT_POSTAL_OPERATOR_EXPANDED,
  SELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS,
  SELECT_ALL_LEFT_POSTAL_OPERATORS,
  SELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS,
  SELECT_ALL_RIGHT_POSTAL_OPERATORS,
  SET_SELECTED_OPERATOR_IMPC_ON_TABLE,
  SWAP_TREES,
  UNSELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS,
  UNSELECT_ALL_LEFT_POSTAL_OPERATORS,
  UNSELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS,
  UNSELECT_ALL_RIGHT_POSTAL_OPERATORS,
} from './types/OperatorImpcActionTypes';

export function retrieveLeftOperatorsWithImpcsByRoleRequestActionCreator(payload) {
  return {
    type: RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST,
    payload,
  };
}

export function retrieveLeftOperatorsWithImpcsByRoleSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS,
    payload,
  };
}

export function retrieveLeftOperatorsWithImpcsByRoleFailureActionCreator(error) {
  return {
    type: RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_FAILURE,
    error,
  };
}

export function retrieveRightOperatorsWithImpcsByRoleRequestActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST,
    payload,
  };
}

export function retrieveRightOperatorsWithImpcsByRoleSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS,
    payload,
  };
}

export function retrieveRightOperatorsWithImpcsByRoleFailureActionCreator(error) {
  return {
    type: RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_FAILURE,
    error,
  };
}

export function retrieveAllLeftOperatorsWithImpcsRequestActionCreator(payload) {
  return {
    type: RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_REQUEST,
    payload,
  };
}

export function retrieveAllLeftOperatorsWithImpcsSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_SUCCESS,
    payload,
  };
}

export function retrieveAllLeftOperatorsWithImpcsFailureActionCreator(error) {
  return {
    type: RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_FAILURE,
    error,
  };
}

export function retrieveAllRightOperatorsWithImpcsRequestActionCreator(payload) {
  return {
    type: RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_REQUEST,
    payload,
  };
}

export function retrieveAllRightOperatorsWithImpcsSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_SUCCESS,
    payload,
  };
}

export function retrieveAllRightOperatorsWithImpcsFailureActionCreator(error) {
  return {
    type: RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_FAILURE,
    error,
  };
}

export function retrieveLeftOperatorsByRoleRequestActionCreator(payload) {
  return {
    type: RETRIEVE_LEFT_OPERATORS_BY_ROLE_REQUEST,
    payload,
  };
}

export function retrieveLeftOperatorsByRoleSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_LEFT_OPERATORS_BY_ROLE_SUCCESS,
    payload,
  };
}

export function retrieveLeftOperatorsByRoleFailureActionCreator(error) {
  return {
    type: RETRIEVE_LEFT_OPERATORS_BY_ROLE_FAILURE,
    error,
  };
}

export function retrieveRightOperatorsByRoleRequestActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_OPERATORS_BY_ROLE_REQUEST,
    payload,
  };
}

export function retrieveRightOperatorsByRoleSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_OPERATORS_BY_ROLE_SUCCESS,
    payload,
  };
}

export function retrieveRightOperatorsByRoleFailureActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_OPERATORS_BY_ROLE_FAILURE,
    payload,
  };
}

export function retrieveAllLeftOperatorsRequestActionCreator(payload) {
  return {
    type: RETRIEVE_ALL_LEFT_OPERATORS_REQUEST,
    payload,
  };
}

export function retrieveAllLeftOperatorsSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_ALL_LEFT_OPERATORS_SUCCESS,
    payload,
  };
}

export function retrieveAllLeftOperatorsFailureActionCreator(error) {
  return {
    type: RETRIEVE_ALL_LEFT_OPERATORS_FAILURE,
    error,
  };
}

export function retrieveAllRightOperatorsRequestActionCreator(payload) {
  return {
    type: RETRIEVE_ALL_RIGHT_OPERATORS_REQUEST,
    payload,
  };
}

export function retrieveAllRightOperatorsSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_ALL_RIGHT_OPERATORS_SUCCESS,
    payload,
  };
}

export function retrieveAllRightOperatorsFailureActionCreator(error) {
  return {
    type: RETRIEVE_ALL_RIGHT_OPERATORS_FAILURE,
    error,
  };
}

export function retrieveLeftGlobalImpcPresetRequestActionCreator(payload) {
  return {
    type: RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_REQUEST,
    payload,
  };
}

export function retrieveLeftGlobalImpcPresetSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_SUCCESS,
    payload,
  };
}

export function retrieveLeftGlobalImpcPresetFailureActionCreator(error) {
  return {
    type: RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_FAILURE,
    error,
  };
}

export function retrieveLeftGlobalOperatorPresetRequestActionCreator(payload) {
  return {
    type: RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_REQUEST,
    payload,
  };
}

export function retrieveLeftGlobalOperatorPresetSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_SUCCESS,
    payload,
  };
}

export function retrieveLeftGlobalOperatorPresetFailureActionCreator(error) {
  return {
    type: RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_FAILURE,
    error,
  };
}

export function retrieveRightGlobalImpcPresetRequestActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_REQUEST,
    payload,
  };
}

export function retrieveRightGlobalImpcPresetSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_SUCCESS,
    payload,
  };
}

export function retrieveRightGlobalImpcPresetFailureActionCreator(error) {
  return {
    type: RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_FAILURE,
    error,
  };
}

export function retrieveRightGlobalOperatorPresetRequestActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_REQUEST,
    payload,
  };
}

export function retrieveRightGlobalOperatorPresetSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_SUCCESS,
    payload,
  };
}

export function retrieveRightGlobalOperatorPresetFailureActionCreator(error) {
  return {
    type: RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_FAILURE,
    error,
  };
}

export function retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator(payload) {
  return {
    type: RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST,
    payload,
  };
}

export function retrieveLeftAssetTypeOperatorsWithImpcsSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS,
    payload,
  };
}

export function retrieveLeftAssetTypeOperatorsWithImpcsFailureActionCreator(error) {
  return {
    type: RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_FAILURE,
    error,
  };
}

export function retrieveRightAssetTypeOperatorsWithImpcsRequestActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST,
    payload,
  };
}

export function retrieveRightAssetTypeOperatorsWithImpcsSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS,
    payload,
  };
}

export function retrieveRightAssetTypeOperatorsWithImpcsFailureActionCreator(error) {
  return {
    type: RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_FAILURE,
    error,
  };
}

export function onLeftPostalOperatorExpanded(expandedPostalOperators) {
  return {
    type: LEFT_POSTAL_OPERATOR_EXPANDED,
    expandedPostalOperators,
  };
}

export function onRightPostalOperatorExpanded(expandedPostalOperators) {
  return {
    type: RIGHT_POSTAL_OPERATOR_EXPANDED,
    expandedAllOperators: expandedPostalOperators,
  };
}

export function onLeftPostalOperatorChecked(payload) {
  return {
    type: LEFT_POSTAL_OPERATOR_CHECKED,
    payload,
  };
}

export function onLeftMailProcessingCenterChecked(payload) {
  return {
    type: LEFT_MAIL_PROCESSING_CENTER_CHECKED,
    payload,
  };
}

export function onRightPostalOperatorChecked(payload) {
  return {
    type: RIGHT_POSTAL_OPERATOR_CHECKED,
    payload,
  };
}

export function onRightMailProcessingCenterChecked(payload) {
  return {
    type: RIGHT_MAIL_PROCESSING_CENTER_CHECKED,
    payload,
  };
}

export function setSelectedOperatorImpcOnTable(operatorCode, impcCode) {
  return {
    type: SET_SELECTED_OPERATOR_IMPC_ON_TABLE,
    selectedOperator: operatorCode,
    selectedImpc: impcCode,
  };
}

export function onSelectAllLeftPostalOperators(nodes) {
  return {
    type: SELECT_ALL_LEFT_POSTAL_OPERATORS,
    payload: {
      nodes,
    },
  };
}

export function onSelectAllLeftMailProcessingCenters(nodes) {
  return {
    type: SELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS,
    payload: {
      nodes,
    },
  };
}

export function onSelectAllRightPostalOperators(nodes) {
  return {
    type: SELECT_ALL_RIGHT_POSTAL_OPERATORS,
    payload: {
      nodes,
    },
  };
}

export function onSelectAllRightMailProcessingCenters(nodes) {
  return {
    type: SELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS,
    payload: {
      nodes,
    },
  };
}

export function onUnselectAllLeftPostalOperators() {
  return {
    type: UNSELECT_ALL_LEFT_POSTAL_OPERATORS,
  };
}

export function onUnselectAllRightPostalOperators() {
  return {
    type: UNSELECT_ALL_RIGHT_POSTAL_OPERATORS,
  };
}

export function onUnselectAllLeftMailProcessingCenters() {
  return {
    type: UNSELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS,
  };
}

export function onUnselectAllRightMailProcessingCenters() {
  return {
    type: UNSELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS,
  };
}

export function onSwapTrees(payload) {
  return {
    type: SWAP_TREES,
    payload,
  };
}
